'use strict';

require('../../style/index.css');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.13.2@antd/lib/icon/style/css.js
// module id = 964
// module chunks = 0